import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76598bd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: "/assets/img/logo-small.svg"
  })
], -1))
const _hoisted_2 = {
  key: 0,
  class: "m-direction"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<p data-v-76598bd9> これからJETの<ruby data-v-76598bd9>試験<rt data-v-76598bd9>しけん</rt></ruby>を<ruby data-v-76598bd9>始<rt data-v-76598bd9>はじ</rt></ruby>めます。<ruby data-v-76598bd9>以下<rt data-v-76598bd9>いか</rt></ruby>の<ruby data-v-76598bd9>内容<rt data-v-76598bd9>ないよう</rt></ruby>を<ruby data-v-76598bd9>確認<rt data-v-76598bd9>かくにん</rt></ruby>してください。 </p>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "start-card"
}
const _hoisted_6 = { class: "start-card__header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("級"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "きゅう"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_8 = { class: "start-card__body" }
const _hoisted_9 = { class: "start-card__table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("検定"),
  /*#__PURE__*/_createElementVNode("rt", null, "けんてい")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("会員番号"),
  /*#__PURE__*/_createElementVNode("rt", null, "かいいんばんごう")
], -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("受検番号"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "じゅけんばんごう"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("お"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("名前"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "なまえ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("ローマ"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("字"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "じ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1))
const _hoisted_19 = { class: "en-font" }
const _hoisted_20 = { class: "start-card__table separate" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("学年"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "がくねん"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("性別"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "せいべつ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("生年月日"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "せいねんがっぴ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1))
const _hoisted_24 = {
  key: 2,
  class: "m-inform"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<p data-v-76598bd9><ruby data-v-76598bd9>間違<rp data-v-76598bd9>（</rp><rt data-v-76598bd9>まちが</rt><rp data-v-76598bd9>）</rp></ruby>っているところがあれば<ruby data-v-76598bd9>先生<rp data-v-76598bd9>（</rp><rt data-v-76598bd9>せんせい</rt><rp data-v-76598bd9>）</rp></ruby>に<ruby data-v-76598bd9>知<rp data-v-76598bd9>（</rp><rt data-v-76598bd9>し</rt><rp data-v-76598bd9>）</rp></ruby>らせてください。 </p>", 1)
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "知らせる", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 3,
  class: "m-direction"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("間違"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "まちが"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("っているものにチェックをつけてください。 ")
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 4,
  class: "m-direction"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<p data-v-76598bd9> ローマ<ruby data-v-76598bd9>字<rt data-v-76598bd9>じ</rt></ruby><ruby data-v-76598bd9>名<rt data-v-76598bd9>めい</rt></ruby>はマイページで<ruby data-v-76598bd9>修正<rt data-v-76598bd9>しゅうせい</rt></ruby>することができます。<br data-v-76598bd9> その<ruby data-v-76598bd9>他<rt data-v-76598bd9>た</rt></ruby>の<ruby data-v-76598bd9>項目<rt data-v-76598bd9>こうもく</rt></ruby>について<ruby data-v-76598bd9>間違<rt data-v-76598bd9>まちが</rt></ruby>いがある<ruby data-v-76598bd9>場合<rt data-v-76598bd9>ばあい</rt></ruby>は<ruby data-v-76598bd9>所属<rt data-v-76598bd9>しょぞく</rt></ruby>の<ruby data-v-76598bd9>教室<rt data-v-76598bd9>きょうしつ</rt></ruby>までご<ruby data-v-76598bd9>連絡<rt data-v-76598bd9>れんらく</rt></ruby>ください。 </p>", 1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("次"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "つぎ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("へ")
], -1))
const _hoisted_35 = [
  _hoisted_34
]

import {ref, inject, reactive} from "vue"
import { useRoute, useRouter } from 'vue-router'
import CheckBox from '@/components/parts/CheckBox.vue'
import { examKey } from "@/main";
import {QuestionData, WrongMarks} from "@/store/exam";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Start',
  emits: ['overridePageName'],
  setup(__props) {

const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const group = route.params.group;

const questions = ref<QuestionData>();
const rank = ref<string | null>(null);
const rankName = ref<string | null>(null);
const name = ref<string | null>(null);
const examineeNumber = ref<string | null>(null);
const nameEn = ref<string | null>(null);
const schoolGrade = ref<string | null>(null);
const sex = ref<string | null>(null);
const dateOfBirth = ref<string | null>(null);
const edit = ref<boolean>(false);

const wrongMarks: WrongMarks = reactive({
  name: false,
  nameEn: false,
  schoolGrade: false,
  sex: false,
  dateOfBirth: false,
});

const init = async () => {
  questions.value = await exam?.questions();
  if (!questions.value) return;
  rank.value = questions.value.rank;
  rankName.value = questions.value.name;

  const examinee = await exam?.examinee();
  if (examinee) {
    examineeNumber.value = examinee.examineeNumber;
    name.value = examinee.name;
    nameEn.value = examinee.nameEn;
    schoolGrade.value = examinee.schoolGrade;
    sex.value = examinee.sex;
    dateOfBirth.value = examinee.dateOfBirth;
  }
}
init();

const next = async () => {
  exam?.startFullScreen();
  if (edit.value) {
    const session = await exam?.session();
    if (session) {
      session.cbtCode = typeof group === 'string' ? group : group[0]
      session.wrongMarks = wrongMarks;
    }
    await exam?.saveSession();
  }
  router.replace(`/cbt/${group}/volume`)
}

const gakken = exam?.isGakken();

const demoPrev = () => router.replace(`/cbt/${group}/login`);
const demoNext = next;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (rank.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (rank.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(rank.value), 1),
                _hoisted_7
              ]),
              _createElementVNode("span", null, _toDisplayString(rankName.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("colgroup", null, [
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: _unref(gakken) ? '45%' : '15%' })
                }, null, 4)
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  (_unref(gakken))
                    ? (_openBlock(), _createElementBlock("th", _hoisted_10, [
                        _hoisted_11,
                        _hoisted_12,
                        _createTextVNode("ターゲットコースの"),
                        _hoisted_13
                      ]))
                    : (_openBlock(), _createElementBlock("th", _hoisted_14, _hoisted_16)),
                  _createElementVNode("td", null, _toDisplayString(examineeNumber.value), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_17,
                  _createElementVNode("td", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (wrongMarks.name = edit.value && !wrongMarks.name)),
                    class: _normalizeClass({checked:wrongMarks.name})
                  }, [
                    (!_unref(gakken))
                      ? (_openBlock(), _createBlock(CheckBox, {
                          key: 0,
                          show: edit.value,
                          checked: wrongMarks.name
                        }, null, 8, ["show", "checked"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(name.value), 1)
                  ], 2)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (wrongMarks.nameEn = edit.value && !wrongMarks.nameEn)),
                    class: _normalizeClass({checked:wrongMarks.nameEn})
                  }, [
                    (!_unref(gakken))
                      ? (_openBlock(), _createBlock(CheckBox, {
                          key: 0,
                          show: edit.value,
                          checked: wrongMarks.nameEn
                        }, null, 8, ["show", "checked"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(nameEn.value), 1)
                  ], 2)
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_20, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_21,
                  _createElementVNode("td", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (wrongMarks.schoolGrade = edit.value && !wrongMarks.schoolGrade)),
                    class: _normalizeClass({checked:wrongMarks.schoolGrade})
                  }, [
                    (!_unref(gakken))
                      ? (_openBlock(), _createBlock(CheckBox, {
                          key: 0,
                          show: edit.value,
                          checked: wrongMarks.schoolGrade
                        }, null, 8, ["show", "checked"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(schoolGrade.value), 1)
                  ], 2),
                  _hoisted_22,
                  _createElementVNode("td", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (wrongMarks.sex = edit.value && !wrongMarks.sex)),
                    class: _normalizeClass({checked:wrongMarks.sex})
                  }, [
                    (!_unref(gakken))
                      ? (_openBlock(), _createBlock(CheckBox, {
                          key: 0,
                          show: edit.value,
                          checked: wrongMarks.sex
                        }, null, 8, ["show", "checked"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(sex.value), 1)
                  ], 2),
                  _hoisted_23,
                  _createElementVNode("td", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (wrongMarks.dateOfBirth = edit.value && !wrongMarks.dateOfBirth)),
                    class: _normalizeClass({checked:wrongMarks.dateOfBirth})
                  }, [
                    (!_unref(gakken))
                      ? (_openBlock(), _createBlock(CheckBox, {
                          key: 0,
                          show: edit.value,
                          checked: wrongMarks.dateOfBirth
                        }, null, 8, ["show", "checked"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(dateOfBirth.value), 1)
                  ], 2)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (rank.value && !edit.value && !_unref(gakken))
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (edit.value = true)),
            class: "m-btn secondary"
          }, _hoisted_27)
        ]))
      : _createCommentVNode("", true),
    (rank.value && edit.value && !_unref(gakken))
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
      : _createCommentVNode("", true),
    (_unref(gakken) && rank.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
      : _createCommentVNode("", true),
    (rank.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 5,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (next())),
          class: "m-btn is-center"
        }, _hoisted_35))
      : _createCommentVNode("", true),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: _unref(demoNext),
      prev: false,
      next: false
    }, null, 8, ["onNext"])
  ], 64))
}
}

})